export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  funcionariosId: {
    value: [],
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/regional/components/add/regionalAdd-form.js